// filepath: apps/web/src/features/admin/forms/FormsListRoute.tsx
//
// FR-UI-BLD-1 / ISS-f4fa1b7b-258 - staging-only-gated placeholder
// route for /admin/forms.

import React from "react";
import { StagingOnlyError } from "@/features/admin/StagingOnlyError";
import { FormsListPage } from "./FormsListPage";

interface FormsListRouteProps {
  environmentKind: string;
}

export function FormsListRoute({
  environmentKind,
}: FormsListRouteProps): React.ReactElement {
  if (environmentKind !== "staging") {
    return <StagingOnlyError environmentKind={environmentKind} />;
  }
  return <FormsListPage />;
}
